<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>
        {{ $t("subscriptionToUpgradeTo") }} <span class="text-danger">*</span>
      </template>
      <treeselect
        v-model="subscriptionPlanId"
        :options="subscriptionPlanOptions"
        :placeholder="$t('chooseSubscription')"
        @input="chooseSubscription"
        :clearable="false"
        :searchable="true"
      />
    </b-form-group>
    <p v-if="!selectedSubscriptionPlan" class="text-secondary">{{ $t("chooseSubscriptionNote") }}</p>
    <template v-if="selectedSubscriptionPlan">
      <template v-if="selectedSubscriptionPlan.managementType === enumManagementType.CONCURRENT_PARTICIPANT_POOL">
        <b-form-group>
          <template v-slot:label>
            {{ $t("maxParticipantPool") }}
          </template>
          <b-form-input v-model="meetingConcurrentParticipantsLimit" type="number" min="1" required />
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group>
          <template v-slot:label>
            {{ $t("numberOfConcurrentMeetings") }}
          </template>
          <b-form-input v-model="numberOfConcurrentMeetings" type="number" min="1" required />
        </b-form-group>
        <b-form-group>
          <template v-slot:label>
            {{ $t("numOfParticipants") }}
          </template>
          <b-form-input v-model="meetingConcurrentParticipantsLimit" type="number" min="1" required />
        </b-form-group>
      </template>
      <div class="border-bottom pb-3 mb-3">
        <b-form-row>
          <b-col cols="6"><label>{{ $t("subscriptionInfo") }}</label></b-col>
        </b-form-row>
        <!-- subscriptionLength: Thời hạn sử dụng -->
        <b-form-row>
          <b-col cols="6">{{ $t("subscriptionLength") }}</b-col>
          <b-col cols="6" style="display: flex;">
            <b>{{ numOfMonth }}</b>
            <b style="margin-left: 4px;margin-right: 4px;;"> {{ selectedSubscriptionPlan.unitTimeVN }}</b>
          </b-col>
        </b-form-row>
        <b-form-row v-for="(row, idx) in planInfoRows" :key="idx">
          <b-col cols="6">{{ $t(row.label) }}</b-col>
          <b-col cols="6">
            <b>{{ row.value }}</b>
            <b v-if="row.suffix" style="margin-left: 4px;">{{ $t(row.suffix) }}</b>
          </b-col>
        </b-form-row>
      </div>
      <div class="mb-3">
        <label>{{ $t("serviceInfo") }}</label>
         <b-form-row>
          <b-col cols="6">{{ $t("expDate") }}</b-col>
          <b-col cols="6"><b>{{ expDateStr }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("servicePrice") }}</b-col>
          <b-col cols="6"><b>{{ priceStr }} VND</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("vatTax") }}</b-col>
          <b-col cols="6"><b>{{ taxAmountStr }} VND</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("amountCustomerToPay") }}</b-col>
          <b-col cols="6"><b>{{ dueAmountStr }} VND</b></b-col>
        </b-form-row>
      </div>
      <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>
      <div class="text-right mt-4">
        <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{
          $t("cancel") }}</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("upgradeService") }}</b-button>
      </div>
    </template>
  </b-form>
</template>
<style lang="scss" scoped>
/* Đảm bảo z-index của treeselect cao hơn modal nếu cần */
::v-deep .vue-treeselect__menu-container {
  z-index: 9999 !important;
}
</style>
<script lang="ts">
import { Component, Emit, Prop } from 'vue-property-decorator';
import _ from "lodash";
import moment from "moment";
import BaseComponent from "@/components/BaseComponent";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import * as customerService from "@/service/customerService";
import BigNumber from "bignumber.js";
import { SubscriptionUnitTime } from "@/views/enums/unitTime";
import Treeselect from '@riophae/vue-treeselect';
import * as subscriptionUtil from "@/service/subscriptionUtil";
import { ManagementType } from "@/views/enums/subscriptionAction";

const VAT_RATE = 0.1;

@Component({
  components: { Treeselect }
})
export default class UpgradeSubscriptionModal extends BaseComponent {
  enumManagementType = ManagementType;
  datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
  @Prop({ required: true }) customerSubscription;
  @Emit("submitted") __submitted() { }

  subscriptionPlans = [];
  subscriptionPlanId: number = null;
  selectedSubscriptionPlan: any = null;
  startTime: string = null;
  startDate: string = null;
  startDateMaxValue: string = null;
  upgradeOption = 0;
  upgradeOptions = [
    { value: 0, text: this.$t("upgradeOption0").toString() },
    { value: 1, text: this.$t("upgradeOption1").toString() },
  ];
  numOfMonth: number | string = 1;
  numberOfConcurrentMeetings = 0;
  meetingConcurrentParticipantsLimit = 0;
  formErrorMsg = "";
  isSubmitting = false;
  // Emit decorators only

  mounted() {
    this.startDate = moment().format("YYYY-MM-DD");
    this.startDateMaxValue = moment(this.customerSubscription.endTime).format("YYYY-MM-DD");
    this.fetchSubscriptionPlans();
  }


  async fetchSubscriptionPlans() {
    try {
      this.subscriptionPlans = await subscriptionPlanService.getPlans();
      } catch (e) {
      this.toastError(e);
    }
  }


  durationLimits() {
    if (!this.selectedSubscriptionPlan) {
      return { min: 1, max: 36 };
    }
    switch (this.selectedSubscriptionPlan.unitTime) {
      case SubscriptionUnitTime.months:
        return { min: 1, max: 36 };
      case SubscriptionUnitTime.years:
        return { min: 1, max: 3 };
      case SubscriptionUnitTime.days:
        return { min: 1, max: 365 };
      default:
        return { min: 1, max: 36 };
    }
  }


  get subscriptionPlanOptions() {
    return this.subscriptionPlans.map(it => ({
      id: it.id,
      label: `${it.name} - ${this.formatCurrencyAmount(it.price)} VND / ${it.unitTimeVN === 'Ngày' ? it.numberOfDaysUsage : 1} ${it.unitTimeVN}`,
    }));
  }


  get planInfoRows() {
    const active = {
      maxParticipantPool: this.selectedSubscriptionPlan.maxParticipantPool,
      meetingConcurrentParticipantsLimit: this.meetingConcurrentParticipantsLimit,
      numberOfConcurrentMeetings: this.numberOfConcurrentMeetings
    };
    const rows = subscriptionUtil.buildPlanInfoRows(active, this.selectedSubscriptionPlan);
    if (this.selectedSubscriptionPlan.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL) {
      return rows.filter(row => row.label !== 'maxParticipantPool');
    } else {
      return rows.filter(row => row.label !== 'maximumNumberOfParticipantsInMeeting' && row.label !== 'numberOfConcurrentMeetings');
    }
  }

  get unitPrice(): BigNumber {
    if (!this.selectedSubscriptionPlan || !this.selectedSubscriptionPlan.numberOfDaysUsage) {
      return new BigNumber(0);
    }
    // Assuming 'numberOfDaysUsage' is a misnomer and actually means duration in 'unitTime' units.
    return new BigNumber(this.selectedSubscriptionPlan.price).dividedBy(this.selectedSubscriptionPlan.numberOfDaysUsage);
  }


  get subtotal(): BigNumber {
    if (!this.selectedSubscriptionPlan) {
      return new BigNumber(0);
    }
    return this.unitPrice.multipliedBy(this.numOfMonth);
  }

  get taxAmount(): BigNumber {
    return this.subtotal.multipliedBy(VAT_RATE);
  }


  // Hàm tính toán thời gian hết hạn
  get expDateStr(): string {
    if (!this.selectedSubscriptionPlan) {
      return "";
    }

    return moment(this.startDate, "YYYY-MM-DD")
      .add(this.numOfMonth, this.selectedSubscriptionPlan.unitTime)
      .format("DD/MM/YYYY");
  }


  // Hiển thị giá tiền chưa thuế
  get priceStr(): string {
    if (!this.selectedSubscriptionPlan) return "0";
    return this.formatCurrencyAmount(this.subtotal.decimalPlaces(0).toNumber());
  }


  // Hiển thị thuế VAT
  get taxAmountStr(): string {
    if (!this.selectedSubscriptionPlan) return "0";
    return this.formatCurrencyAmount(this.taxAmount.decimalPlaces(0).toNumber());
  }


  // Hiển thị giá tiền đã bao gồm thuế
  get dueAmountStr(): string {
    if (!this.selectedSubscriptionPlan) return "0";
    return this.formatCurrencyAmount(this.subtotal.plus(this.taxAmount).decimalPlaces(0).toNumber());
  }


  onClickCancel() {
    this.$bvModal.hide("upgrade-subscription-modal");
  }


  chooseSubscription(id: number) {
    this.selectedSubscriptionPlan = this.subscriptionPlans.find(it => it.id === id) || null;

    if (this.selectedSubscriptionPlan) {
      if (this.selectedSubscriptionPlan.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL) {
        this.numberOfConcurrentMeetings = 0;
        this.meetingConcurrentParticipantsLimit = this.customerSubscription?.maxParticipantPool || this.selectedSubscriptionPlan.maxParticipantPool;
      } else {
        this.numberOfConcurrentMeetings = this.customerSubscription?.numberOfConcurrentMeetings || this.selectedSubscriptionPlan.numberOfConcurrentMeetings;
        this.meetingConcurrentParticipantsLimit = this.customerSubscription?.meetingConcurrentParticipantsLimit || this.selectedSubscriptionPlan.maximumNumberOfParticipantsInMeeting;
      }
      // Assuming 'numberOfDaysUsage' is a misnomer for duration in the given unit.
      this.numOfMonth = this.selectedSubscriptionPlan.numberOfDaysUsage;
    } else {
      this.numberOfConcurrentMeetings = 0;
      this.meetingConcurrentParticipantsLimit = 0;
      this.numOfMonth = 1;
    }
  }


  async submitForm() {
    const isPool = this.selectedSubscriptionPlan.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL;
    console.log("=== submitForm ===");
    console.log("selectedSubscriptionPlan:", this.selectedSubscriptionPlan);
    console.log("isPool:", isPool);
    console.log("this.numberOfConcurrentMeetings:", this.numberOfConcurrentMeetings);
    console.log("this.meetingConcurrentParticipantsLimit:", this.meetingConcurrentParticipantsLimit);

    const data = {
      customerId: this.customerSubscription.customerId,
      newSubscriptionPlanId: this.subscriptionPlanId,
      numberOfConcurrentMeetings: isPool ? null : +this.numberOfConcurrentMeetings,
      meetingConcurrentParticipantsLimit: isPool ? null : +this.meetingConcurrentParticipantsLimit,
      maxParticipantPool: isPool ? +this.meetingConcurrentParticipantsLimit : null,
    };
    console.log("data payload to send:", data);

    try {
      this.isSubmitting = true;
      await customerService.cancelAndRegisterNewSubscription(data);
      this.__submitted();
      this.$bvModal.hide("upgrade-subscription-modal");
      this.toastSuccessDelay(this.$t("upgradeServiceSuccessful").toString());

    } catch (e) {    
      // Use the base component's error handler for consistency
      this.toastError(e);
    } finally {
      this.isSubmitting = false;
    }
  }
}
</script>
